var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendaricon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200-607.69h560v-100.001q0-4.616-3.846-8.463-3.847-3.846-8.463-3.846H212.309q-4.616 0-8.463 3.846-3.846 3.847-3.846 8.463v100.001Zm0 0V-720v112.31Zm12.309 507.689q-30.308 0-51.308-21t-21-51.308v-535.382q0-30.308 21-51.308t51.308-21h55.385v-84.615h61.537v84.615h303.076v-84.615h59.999v84.615h55.385q30.308 0 51.308 21t21 51.308v218.537q-14.385-6.307-29.384-10.192-15-3.884-30.615-6.115v-42.23H200v375.382q0 4.616 3.846 8.463 3.847 3.846 8.463 3.846h260.077q5.077 16.615 12.269 31.422 7.192 14.808 16.346 28.577H212.309Zm515.384 40q-74.923 0-127.461-52.538Q547.694-165.078 547.694-240t52.538-127.461q52.538-52.538 127.461-52.538 74.922 0 127.46 52.538Q907.691-314.922 907.691-240t-52.538 127.461q-52.538 52.538-127.46 52.538Zm66.615-88.461 24.923-24.923-73.846-73.846v-110.461h-35.384v124.923l84.307 84.307Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendaricon);
export default __webpack_public_path__ + "static/media/calendar.icon.326c0ce3b5471452c9959cb16ed8be15.svg";
export { ForwardRef as ReactComponent };